<script setup lang="ts">
import api from "@/modules/api";
import { useMate } from "@/stores/mate";
import { useMoment } from "@/stores/moment";
import { useStory } from "@/stores/story";
import { useStoryBook } from "@/stores/story-book";
import { Story } from "@/types/entity";
import { Popup, showFailToast, showLoadingToast, showSuccessToast } from "vant";
import { PropType, ref } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  story: {
    type: Object as PropType<Story>,
    required: true,
  },
  mediaId: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["update:show"]);

const { t } = useI18n();

const publishMomentText = ref("");
const onPublishStory = async () => {
  if (!publishMomentText.value) {
    showFailToast(t("Message.notWrittenIntro"));
    return;
  }

  const loadingToast = showLoadingToast({
    message: t("Message.releasingChapterUniverse"),
  });
  try {
    const { id, storyBookId, storyBook } = props.story! || {};
    const dtPublish = new Date().toISOString();
    if (!props.story.dtPublish)
      await useStory().updateStory(id!, { dtPublish });
    if (storyBook && !storyBook.dtPublish) {
      await useStoryBook().updateStoryBook(storyBookId!, { dtPublish });
    }
    const mate = useMate();
    await api.createMoment({
      mateId: mate.currentMate!.uuid,
      storyId: id,
      mediaIdzz: [props.mediaId],
      text: publishMomentText.value,
      visibility: 1,
      status: 1,
    });
    const moment = useMoment();
    await moment.fetchMomentList(false, 0);
    showSuccessToast(t("Message.publishSuccess"));
    emit("update:show", false);
  } finally {
    loadingToast.close();
  }
};
</script>
<template>
  <popup
    :show="show"
    @update:show="emit('update:show', $event)"
    position="center"
    class="py-10 px-10"
    round
    teleport="body"
  >
    <div class="flex flex-col items-center justify-center w-full h-full gap-5">
      <div class="flex flex-col items-center justify-center gap-2">
        <i class="iconfont icon-script-game text-[40px] text-my-gray"></i>
        <div class="text-lg font-bold text-base-content/50">
          {{ $t("Texts.whenVideoPublishedYourFeed") }}
        </div>
      </div>
      <div class="flex flex-col gap-2 w-full">
        <div class="flex flex-col gap-2">
          <span class="font-bold">{{ $t("Texts.contentChapter") }}</span>
          <textarea
            v-model="publishMomentText"
            class="textarea textarea-bordered"
            :placeholder="$t('Texts.contentChapterPlaceholder')"
          />
        </div>
      </div>
      <div class="flex gap-2 justify-between items-center">
        <button
          class="btn rounded btn-primary btn-sm flex-1"
          @click="onPublishStory"
        >
          {{ $t("Buttons.publish") }}
        </button>
        <button
          class="btn rounded btn-sm flex-1"
          @click="emit('update:show', false)"
        >
          {{ $t("Buttons.cancel") }}
        </button>
      </div>
    </div>
  </popup>
</template>
